const FALLBACKS = { country: 'de', state: 'region', city: 'ort' };

export const pathSegment = (value, fallback) => {
    const text = (value ?? '').toString().trim().toLowerCase();
    return text ? encodeURIComponent(text) : fallback;
};

/**
 * Gehoert ein Verkaufsort zu diesem Bundesland?
 *
 * Verglichen wird der Wert aus den Daten mit dem aus der Adresse, beide gleich
 * normiert. Eintraege ohne Bundesland fallen nicht durch: Sie stehen unter
 * /region und wuerden sonst nirgends erscheinen.
 *
 * Warum ueberhaupt hier und nicht in der Abfrage: Der state-Filter der API
 * liefert je nach Bundesland nichts zurueck. Fuer Nordrhein-Westfalen greift er,
 * fuer Hessen nicht - beide Seiten sahen deshalb aus, als gaebe es dort keine
 * Verkaufsstellen, obwohl die Daten vorlagen.
 */
export const passtZumBundesland = (location = {}, bundeslandAusPfad) => {
    if (!bundeslandAusPfad) return true;
    const wert = pathSegment(location.state, '');
    if (!wert) return true;
    return wert === pathSegment(bundeslandAusPfad, '');
};

export const buildLocationPath = (location = {}) => {
    const country = pathSegment(location.country, FALLBACKS.country);
    const state = pathSegment(location.state, FALLBACKS.state);
    const city = pathSegment(location.city, FALLBACKS.city);
    return `/imker-in/${country}/${state}/${city}/${location.id}`;
};

export const buildCityPath = (location = {}) => {
    const country = pathSegment(location.country, FALLBACKS.country);
    const state = pathSegment(location.state, FALLBACKS.state);
    const city = pathSegment(location.city, FALLBACKS.city);
    return `/imker-in/${country}/${state}/${city}`;
};
